import createSingle from "./create-single.js";
import getSingle from "./get-single.js";

export default {
	createSingle,
	getSingle,
};
